import { render } from "./Iempty.vue?vue&type=template&id=359a0b5f&scoped=true"
const script = {}

import "./Iempty.vue?vue&type=style&index=0&id=359a0b5f&lang=less&scoped=true"

import exportComponent from "E:\\wwwroot\\abz-shuzi\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-359a0b5f"]])

export default __exports__